module.exports = __webpack_public_path__ + "static/media/pdf-icon.57aaf03d.svg";